import reducerRegistry from 'core/lib/store/reducer-registry';
import {
  GET_LOGIN_USER_INFO,
  GET_LOGIN_USER_INFO_SUCCESS,
  GET_LOGIN_USER_INFO_ERROR
} from "@/action-types/userInfo";
import api from '../apis/pc/user/user'
import userInfoReducer from '../reducers/userInfo'

reducerRegistry.register('userInfo', userInfoReducer)

export function getUserInfo() {
  return {
    types: [GET_LOGIN_USER_INFO, GET_LOGIN_USER_INFO_SUCCESS, GET_LOGIN_USER_INFO_ERROR],
    callAPI: () => api.getLoginUser()
  };
}
